






















































import Vue from "vue";
import iwTabsLanguageSwitcher from "@/encoding/components/buildingBlocks/tabsLanguageSwitcher/TabsLanguageSwitcher.vue";
import iwTooltip from "@/shared/components/Tooltip.vue";
import { v4 as uuidv4 } from "uuid";

export default Vue.extend({

    components: {
        iwTabsLanguageSwitcher: iwTabsLanguageSwitcher,
        iwTooltip: iwTooltip
    },
    data: function() {
        return {
            inputName: "town-planning",
            specificId: uuidv4() as string
        };
    },
    computed: {
        getErrorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"]("property.specificities.BRI.internalFixturesAndFittings.en") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.specificities.BRI.internalFixturesAndFittings.fr") ||
                this.$store.getters["FormModule/getErrorObjectByPath"]("property.specificities.BRI.internalFixturesAndFittings.nl");
        },
        languages: function(): Array<Record<string, unknown>> {
            return [
                {
                    "language": this.$t("english_language"),
                    "prefix": "en",
                    "validate": false,
                },
                {
                    "language": this.$t("french_language"),
                    "prefix": "fr",
                    "validate": false,
                },
                {
                    "language": this.$t("dutch_language"),
                    "prefix": "nl",
                    "validate": false
                }
            ];
        }
    }
});
